import { render, staticRenderFns } from "./donationDetail.vue?vue&type=template&id=60a81262&scoped=true"
import script from "./donationDetail.vue?vue&type=script&lang=js"
export * from "./donationDetail.vue?vue&type=script&lang=js"
import style0 from "./donationDetail.vue?vue&type=style&index=0&id=60a81262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a81262",
  null
  
)

export default component.exports